export default __webpack_public_path__ + "static/ios_course_banner-c9be7e955d8edebba16d4e8b68297ce2.webp";